import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { ResponseGridController } from '../controller/ResponseGridController';

export class ResponseGridWebComponent extends BaseWebComponentElement {
  public controller: ResponseGridController | null;
  private _incidentId: string;

  public constructor() {
    super();

    this.initialSetup({
      controllerConstructor: ResponseGridController,
    });
  }

  get incidentId(): string {
    return this._incidentId;
  }

  set incidentId(incidentId: string) {
    this._incidentId = incidentId;
  }

  /**
   * @throws {Error}
   */
  public async start(): Promise<void> {
    if (!this._incidentId) {
      throw new Error('The response grid needs an incident id in order to start.');
    }

    await super.start();
  }
}
